import api from '../services/api';
import { AI_FEEDBACK_ENABLED, AI_FEEDBACK_SAVE } from '../config/Config';

export async function submitFeedback(moduleContext, implicitSignals, explicitSignals = {}) {
  if (!AI_FEEDBACK_ENABLED) {
    return;
  }

  const payload = {
    ...moduleContext,
    ...implicitSignals,
    ...explicitSignals,
  };

  try {
    await api.post(AI_FEEDBACK_SAVE, payload);
  } catch (e) {
    // Feedback should never interrupt teacher workflow.
    // eslint-disable-next-line no-console
    console.warn('Feedback submission failed silently:', e);
  }
}
